import { ThemeUICSSObject, responsive } from '@apia/theme';

const BodyAside: ThemeUICSSObject = {
  display: responsive({ 0: 'block', 3: 'none' }),
  '.content': {
    background: 'palette.background.paper',

    '.ApplicationMenu': {
      mx: 'auto',
      overflow: 'hidden',
      py: responsive({ 0: 4, 2: 7 }),
      px: responsive({ 0: 4, 2: 0 }),
    },
  },
};

export default BodyAside;
